import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const GuideCreate = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { clients } = app.clients
  const AmazonSalesChannel = React.useContext(SalesChannelsContext)
  const { recall, setRecall } = AmazonSalesChannel
  const { create } = AmazonSalesChannel.guides
  const title = "Añadir Guía"
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={create}
        obj={{code:'', email:'', cost:'', date:'', client:'', purchase:''}}
        types={{code:'text', email:'email', cost:'money', date:'date', client:'select', purchase:'text'}} 
        options={{client:clients.map(c => {return{value:c.id,label:c.name}})}} 
        controlled={{cost:0}}
        changed={{}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>Añadir</Button>
    </Dialog>
  )
}
export default GuideCreate